// extracted by mini-css-extract-plugin
export default {"slots":"trialAvailableSlots_slots__OCsRQ","slot":"trialAvailableSlots_slot__-FTUO","empty":"trialAvailableSlots_empty__xWn6R"};